<template>
  <div class="accordeon">
    <div class="accordeon__item" v-for="(item, i) in items" :key="i">
      <a :href="item.path" target="_blank" class="accordeon__key">{{ item.question }}</a>
      <!-- <div class="accordeon__content" :class="{'active': i === currentActive }">{{ item.answer }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordeon",
  data() {
    return {
      currentActive: null
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    toggleActive(index) {
      if (this.currentActive === index) this.currentActive = null;
      else this.currentActive = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.accordeon {
  &__item {
    // background: url("../assets/icons/pijlnaarrechts.svg") no-repeat  top 5px left 3px;s
    background-size: 5px;
    font-size: 0.8125rem;
    line-height: 1.125rem;
    padding: 0;
    margin-bottom: 20px;
    &:not(:last-child) {
      border-bottom: 1px solid $french-gray;
      padding-bottom: 20px;
    }
  }

  &__key {
    @media screen and (min-width: 574px) {
      font-size: 0.9375rem;
      line-height: 1.125rem;
    }
  }

  &__content {
    display: none;
    margin-top: 10px;
    &.active {
      display: block;
    }
  }
}
</style>